import { Toaster } from 'sonner';
import { useTheme } from 'next-themes';

export const AppToaster = () => {
  const { resolvedTheme } = useTheme();

  return <Toaster position="bottom-right" richColors theme={resolvedTheme === 'dark' ? 'dark' : 'light'} />;
};